/// <reference path="../../../tools/typings/tsd.d.ts"/>

module DealerwareWebContent {
    "use strict";

    export class ResetPasswordController {
        public static $inject: string[] = [
            '$stateParams',
            '$mdDialog'
        ];

        public confirmationToken: string;
        public employee: any;

        constructor(public $stateParams: any, public $mdDialog: any) {
            if (this.$stateParams.reset_password_token) {
                this.employee = {
                    reset_password_token: this.$stateParams.reset_password_token
                };

                this.showModal();
            }
        }

        public showModal() : void {
            this.$mdDialog.show({
                templateUrl: '/content/reset_password/reset_password_modal.html',
                controller: this.resetPasswordModalController,
                locals: { employee: this.employee },
                parent: angular.element(document.body),
                escapeToClose: false,
                clickOutsideToClose: false
            });
        }

        public get resetPasswordModalController() {
            return ($scope: any,
                    $state: any,
                    $mdDialog: any,
                    DealerwareEmployeeModel: any,
                    UserModel: any,
                    CurrentUser: any,
                    $dealerwareNotification: any,
                    employee: any) => {
                $scope.employee = employee;
                $scope.saving = false;

                $scope.savePassword = () => {
                    $scope.saving = true;

                    DealerwareEmployeeModel.resetPassword({
                        promise: true,
                        data: employee
                    }).then(
                        (user: any) => {
                            $scope.saving = false;
                            $mdDialog.hide();

                            CurrentUser.user = new UserModel({});
                            CurrentUser.login({
                                email: user.data.email,
                                password: $scope.employee.password,
                                successCallback: (returnValue: any) => { $state.go('shortcuts.dashboard'); },
                                errorCallback: (response: any) => { $dealerwareNotification.apiError(response); }
                            });
                        },
                        (response: any) => {
                            $scope.saving = false;
                            $dealerwareNotification.apiError(response);
                        }
                    );
                };
            };
        }
    }

    getDealerwareWebContentModule().controller('ResetPasswordController', ResetPasswordController);
}
